import { createAsyncThunk } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import api from "../../api";

export const GetListings = createAsyncThunk(
  "ls/GetListings",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await api.get(`/apartments/user/apartments`, payload);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.message || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAListing = createAsyncThunk(
  "ls/GetAListing",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await api.get(`/apartments/${payload}`, payload);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.message || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetASearchedListing = createAsyncThunk(
  "ls/GetASearchedListing",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log({ payload });
    const {
      type_of_property,
      location,
      rent_per_annum,
      page,
      limit,
      navigate,
      type,
      min,
      max,
      number_of_bedrooms,
      property_address,
    } = payload;
    try {
      const response = await api.get(`/apartments`, {
        params: {
          type_of_property,
          location,
          rent_per_annum,
          page,
          limit,
          type,
          min,
          max,
          number_of_bedrooms,
          property_address,
        },
      });
      navigate("/result");
      return response.data;
    } catch (error) {
      toast.error(error?.response?.message || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeleteAListing = createAsyncThunk(
  "ls/DeleteAListing",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await api.delete(`/apartments/${payload}`, payload);
      toast.success(response?.data?.message);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.message || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createListing = createAsyncThunk(
  "ls/createListing",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await api.post(`/apartments`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(response?.data?.message);
      // redirectUser(VERIFY_OTP);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.message || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateListing = createAsyncThunk(
  "ls/createListing",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const appURL = new URLSearchParams(window.location.search);
    try {
      const response = await api.put(
        `/apartments/${appURL.get("listing")}`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.success(response?.data?.message);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.message || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteListingImage = createAsyncThunk(
  "ls/DeleteAListing",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const appURL = new URLSearchParams(window.location.search);

    try {
      const response = await api.put(
        `/apartments/${appURL.get("listing")}/remove/images`,
        {
          name: payload,
        }
      );
      toast.success(response?.data?.message);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.message || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const markListingAsOccupied = createAsyncThunk(
  "ls/DeleteAListing",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const appURL = new URLSearchParams(window.location.search);
    // console.log(appURL.get("listing"));
    try {
      const response = await api.put(`/apartments/update/market/${payload}`, {
        market_status: "occupied",
      });
      toast.success(response?.data?.message);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.message || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  auth: {},
};

export const ListingSlice = createSlice({
  name: "listing",
  initialState,
  reducers: {
    selectedListing(state, action) {
      return {
        ...state,
        selected_listing: action.payload,
      };
    },

    createAppListing(state, action) {
      return {
        ...state,
        created_listing: action.payload,
      };
    },

    completedListingSteps(state, { payload }) {
      // console.log()
      // const steps = {...payload?.listingSteps, ...payload?.listingSteps}
      let data = [];
      const v = data?.push(...data, payload?.listingSteps);

      // console.log({ v, payload, data });
      return {
        ...state,
        listingSteps: data,
        nextListingStep: payload?.nextListingStep,
        prevListingStep: payload?.prevListingStep,
      };
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(GetListings.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(GetListings.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          listings: action.payload,
        };
      })
      .addCase(GetListings.rejected, (state, action) => {
        return {
          isLoading: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetAListing.pending, (state) => {
        return {
          ...state,
          isLoadingListing: true,
        };
      })
      .addCase(GetAListing.fulfilled, (state, action) => {
        return {
          ...state,
          isLoadingListing: false,
          isSuccessful: true,
          listing: action.payload,
        };
      })
      .addCase(GetAListing.rejected, (state, action) => {
        return {
          isLoadingListing: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetASearchedListing.pending, (state) => {
        return {
          ...state,
          isLoadingListing: true,
        };
      })
      .addCase(GetASearchedListing.fulfilled, (state, action) => {
        return {
          ...state,
          isLoadingListing: false,
          isSuccessful: true,
          listing: action.payload,
        };
      })
      .addCase(GetASearchedListing.rejected, (state, action) => {
        return {
          isLoadingListing: false,
          error: action.payload,
        };
      });

    builder
      .addCase(DeleteAListing.pending, (state) => {
        return {
          ...state,
          isDeleting: true,
        };
      })
      .addCase(DeleteAListing.fulfilled, (state, action) => {
        return {
          ...state,
          isDeleting: false,
          isSuccessful: true,
          deleted_listings: action.payload,
        };
      })
      .addCase(DeleteAListing.rejected, (state, action) => {
        return {
          ...state,
          isDeleting: false,
          error: action.payload,
        };
      });

    builder
      .addCase(createListing.pending, (state) => {
        return {
          ...state,
          isCreating: true,
        };
      })
      .addCase(createListing.fulfilled, (state, action) => {
        return {
          ...state,
          isCreating: false,
          isSuccessful: true,
          create_listing: action.payload,
        };
      })
      .addCase(createListing.rejected, (state, action) => {
        return {
          ...state,
          isCreating: false,
          error: action.payload,
        };
      });
  },
});

export const { selectedListing, createAppListing, completedListingSteps } =
  ListingSlice.actions;

export default ListingSlice.reducer;
